'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var _commonjsHelpers = require('../../_virtual/_commonjsHelpers.js');
var reactIs_production_min = require('./cjs/react-is.production.min.js');
var reactIs_development = require('./cjs/react-is.development.js');

var reactIs = _commonjsHelpers.createCommonjsModule(function (module) {

if (process.env.NODE_ENV === 'production') {
  module.exports = reactIs_production_min['default'];
} else {
  module.exports = reactIs_development['default'];
}
});

exports.__moduleExports = reactIs;
exports.default = reactIs;
//# sourceMappingURL=index.js.map
